import React from "react";
import PropTypes from "prop-types";

const ClientBranding = ({ logoUrl, companyName }) => {
  return (
    <div className="flex items-center justify-center">
      <img
        src={logoUrl || require("../../../assets/images/VIGenericLogo.png")}
        alt="Employer Logo"
        className="w-32 h-32 object-contain mb-4"
      />
      <h1 className="text-3xl font-bold font-sans">
        {companyName || "Your Company Name"}
      </h1>
    </div>
  );
};

ClientBranding.propTypes = {
  logoUrl: PropTypes.string,
  companyName: PropTypes.string,
};

export default ClientBranding;
